// extracted by mini-css-extract-plugin
module.exports = {"successBanner":"styles_successBanner__2mi00"};